export enum AggrtMode {
  READ = 'read',
  WRITE = 'write',
  UPDATE = 'update',
}
